"use client"

import { AlertCircle } from "react-feather"

interface ErrorBoundaryProps {
  error?: Error | unknown
  resetErrorBoundary?: () => void
  customMessage?: string
}

export function ErrorBoundary({ error, customMessage }: ErrorBoundaryProps) {
  console.error("ErrorBoundary caught an error:", error)

  const getErrorMessage = () => {
    if (customMessage) return customMessage

    if (error instanceof Error) {
      // APIエラーの場合
      if (error.message.includes("401") || error.message.includes("Unauthorized")) {
        return "アクセス権限がありません。ログインし直してください。"
      }
      if (error.message.includes("403") || error.message.includes("Forbidden")) {
        return "このページへのアクセスが拒否されました。"
      }
      if (error.message.includes("404") || error.message.includes("Not Found")) {
        return "お探しのデータが見つかりませんでした。"
      }
      if (error.message.includes("500") || error.message.includes("Internal Server Error")) {
        return "サーバーエラーが発生しました。しばらく経ってから再度お試しください。"
      }
      if (error.message.includes("Network") || error.message.includes("fetch")) {
        return "ネットワークエラーが発生しました。インターネット接続を確認してください。"
      }
      return "エラーが発生しました。しばらく経ってから再度お試しください。"
    }

    return "エラーが発生しました。しばらく経ってから再度お試しください。"
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-6">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="flex justify-center">
          <div className="rounded-full bg-red-50 p-3">
            <AlertCircle className="h-8 w-8 text-red-600" />
          </div>
        </div>

        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-slate-900">エラーが発生しました</h2>
          <p className="text-sm text-slate-600">{getErrorMessage()}</p>
        </div>

        {/* エラー詳細（開発環境のみ） */}
        {process.env.NODE_ENV === "development" && error instanceof Error && (
          <details className="text-left">
            <summary className="text-xs text-slate-500 cursor-pointer">
              エラー詳細 (開発環境のみ)
            </summary>
            <pre className="mt-2 p-2 bg-slate-100 rounded text-xs overflow-auto">
              {error.stack || error.message}
            </pre>
          </details>
        )}
      </div>
    </div>
  )
}
